import http from "../../utils/http";
// import { toast } from "../../utils/toast";

// 직원 은행 목록
export const getEmployeeBankList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/salaries/accounts/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 계좌 등록
export const createSalaryAccount = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post('/salaries/accounts', params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 계좌 수정
export const modifySalaryAccount = (accountIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/salaries/accounts/${accountIdx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 은행 삭제
export const deleteEmployeeBankList = (accountIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/salaries/accounts/${accountIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

